import { LOGIN, LOGOUT, SET_LOADING, SET_USERDETAILS, SET_LANGUAGE, SET_OTP_TIME, SET_EMAIl_VERIFIED, SET_DARK_MODE } from "./user.types";


export const setLogin = (payload) => ({
    type: LOGIN,
    payload
});

export const setLogout = () => ({
    type: LOGOUT,
});

export const setLoading = (val) => ({
    type: SET_LOADING,
    payload: val
});

export const setUserDetails = (payload) => ({
    type: SET_USERDETAILS,
    payload
});

export const setLanguage = (val) => ({
    type: SET_LANGUAGE,
    payload: val
});

export const setOtpTime = (val) => ({
    type: SET_OTP_TIME,
    payload: val
});

export const setEmailVerified = (val) => ({
    type: SET_EMAIl_VERIFIED,
    payload: val
});

export const setDarkMode = (val) => ({
    type: SET_DARK_MODE,
    payload: val
});
